import { StyleSheet } from 'react-native'
import { JDDevice } from '@jdreact/jdreact-core-lib'


export default StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1,
    height: JDDevice.getRpx(130),
    borderRadius: JDDevice.getRpx(6),
    overflow: 'hidden'
  },
  image: {
    width: '100%',
    height: JDDevice.getRpx(130),
  }
})
